export default __webpack_public_path__ + "static/media/Latina_Icono2.ecb7d02f.png";